import * as React from 'react';
import { compose, withHandlers, withState, withProps } from 'recompose';
import { reduxForm, change as reduxChange } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { find, get, noop } from 'lodash';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { DefaultField, InlineGrid, InlineGridField } from '@components/form';

import { spsFields } from './_eventsEnums';
import { setMds } from '@utils/utils';
import { attachmentsGridColumns } from './_eventsColumns';
import { Loader } from '@components/loader';
import { EventsFormRecordServicesFormFilesForm } from './EventsFormRecordServicesFormFilesForm';
import { createDocument, deleteAttachment } from '@modules/records/_recordsActions';
import { withNotifications } from '@components/hoc/withNotifications';
import { connect } from 'react-redux';
import { addPragueTz } from '@utils/timezone';
import { ModalButton } from '@components/modalButton/ModalButton';
import { EventsFormRecordServicesFormPhotosForm } from './EventsFormRecordServicesFormPhotosForm';

const formName = 'module-events-record-document-create';

const mapStateToProps = state => ({
  attachments: get(state, `form.module-events-record-document-create.values.attachments`, [])
});

const mapDispatchToProps = dispatch => ({
  setAttachments: attachments => dispatch(reduxChange(formName, 'attachments', attachments))
});

const enhance = compose<any, any>(
  withState('loader', 'setLoader', false),
  reduxForm({
    form: formName,
    enableReinitialize: false
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNotifications({ createDocument, deleteAttachment }),
  withHandlers({
    createDocumentHandler: ({ setLoader, createDocumentNotify, eventId, closeItem, onRefresh }) => async formData => {
      setLoader(true);
      await createDocumentNotify(formData, eventId);
      onRefresh();
      setLoader(false);
      closeItem();
    },
    onDeleteAttachment: ({
      deleteAttachmentNotify,
      initialValues,
      setLoader,
      setAttachments,
      attachments
    }) => async checkedItems => {
      setLoader(true);
      const documentId = initialValues && initialValues.id;
      for (const attachment of checkedItems) {
        await deleteAttachmentNotify(documentId, attachment.id);
      }
      setAttachments(attachments.filter(({ id }) => !find(checkedItems, item => item.id === id)));
      setLoader(false);
    },
    rowStyleFn: ({ files, photos }) => item => {
      let fileDeleted = false;
      let fileUpdated = false;
      const file = [...files, ...photos].find(f => f.id === get(item, 'file.id'));
      if (!file) {
        fileDeleted = true;
      }
      const syncDate = new Date(item.syncDatetime);
      if (file && new Date(file.updated) > addPragueTz(syncDate)) {
        fileUpdated = true;
      }
      if (fileDeleted) {
        return { backgroundColor: '#ffd4d4' };
      }
      if (fileUpdated) {
        return { backgroundColor: '#9393ff' };
      }
      return null;
    },
    onClose: ({ onRefresh, closeItem }) => () => {
      onRefresh();
      closeItem();
    }
  })
);

const View: React.SFC<any> = ({
  handleSubmit,
  createDocumentHandler,
  onClose,
  sps,
  files,
  photos,
  initialValues,
  loader,
  onDeleteAttachment,
  setAttachments,
  attachments,
  rowStyleFn,
  disabled
}) => {
  const documentId = initialValues && initialValues.id;
  const fields: Array<any> = get(spsFields, sps, []).filter(({ firstOnly }) => !firstOnly);
  const mds = setMds(fields.length);
  return (
    <div>
      {loader && <Loader />}
      <form className="layout" onSubmit={handleSubmit(initialValues ? noop : createDocumentHandler)}>
        <Grid fluid={true}>
          <h4>{initialValues ? 'Přílohy dokumentu' : 'Přidání dokumentu'}</h4>
          {!initialValues && (
            <Row>
              <Col className="grid-system-margin" />
            </Row>
          )}
          {!initialValues && (
            <Row>
              {get(spsFields, sps, [])
                .filter(({ firstOnly }) => !firstOnly)
                .map(({ firstOnly, md, name, items = '', ...f }, index) => (
                  <Col md={mds[index]} key={name}>
                    <DefaultField name={name} {...f} />
                  </Col>
                ))}
            </Row>
          )}
          {initialValues && (
            <Row>
              <Col md={12}>
                <InlineGridField
                  component={InlineGrid}
                  name="attachments"
                  Form={withProps({
                    files,
                    documentId,
                    setAttachments,
                    attachments
                  })(EventsFormRecordServicesFormFilesForm)}
                  gridProps={{ showDeleted: false }}
                  columns={attachmentsGridColumns}
                  showCheckboxes={true}
                  adding={!disabled}
                  editing={false}
                  deleting={!disabled}
                  addLabel="Přidat přílohu"
                  onDelete={onDeleteAttachment}
                  rowStyleFn={rowStyleFn}
                  ActionBar={() =>
                    !disabled && (
                      <>
                        <ModalButton
                          label={'Přidat fotodokumentaci'}
                          style={{ margin: '0 10px' }}
                          ModalComponent={withProps({
                            photos,
                            documentId,
                            setAttachments,
                            attachments
                          })(EventsFormRecordServicesFormPhotosForm)}
                        />
                      </>
                    )
                  }
                />
              </Col>
            </Row>
          )}

          <Row>
            <Col className="grid-system-margin" />
          </Row>
        </Grid>

        <Divider />

        {!initialValues && (
          <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        )}
        <Button label="Zavřít" style={{ margin: '16px 0 16px 16px' }} onClick={onClose} />
      </form>
    </div>
  );
};

export const EventsFormRecordServicesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormRecordServicesForm.tsx